import React from 'react';
import { Facebook, Instagram, Youtube, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-text text-white py-16" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-49">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-50">
          <div className="col-span-1 md:col-span-2" data-id="element-51">
            <h3 className="font-serif text-2xl font-bold text-white mb-4" data-id="element-52">
              Daniela Sămărtinean
            </h3>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-53">
              Psihoterapie integrativă, coaching și reconectare spirituală
              pentru o viață trăită în armonie și adevăr.
            </p>
            <div className="flex space-x-4" data-id="element-54">
              <a href="#" className="text-gray-400 hover:text-brand-secondary transition-colors" data-id="element-55">
                <Facebook className="w-6 h-6" data-id="element-56" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-secondary transition-colors" data-id="element-57">
                <Instagram className="w-6 h-6" data-id="element-58" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-secondary transition-colors" data-id="element-59">
                <Youtube className="w-6 h-6" data-id="element-60" />
              </a>
            </div>
          </div>

          <div data-id="element-61">
            <h4 className="font-bold text-lg mb-6 text-brand-secondary" data-id="element-62">
              Linkuri Utile
            </h4>
            <ul className="space-y-3 text-gray-400" data-id="element-63">
              <li data-id="element-64">
                <a href="#despre" className="hover:text-white transition-colors" data-id="element-65">
                  Despre Mine
                </a>
              </li>
              <li data-id="element-66">
                <a href="#metoda" className="hover:text-white transition-colors" data-id="element-67">
                  Metoda 3S
                </a>
              </li>
              <li data-id="element-68">
                <a href="#servicii" className="hover:text-white transition-colors" data-id="element-69">
                  Servicii
                </a>
              </li>
              <li data-id="element-70">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-71">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-72">
            <h4 className="font-bold text-lg mb-6 text-brand-secondary" data-id="element-73">
              Legal
            </h4>
            <ul className="space-y-3 text-gray-400" data-id="element-74">
              <li data-id="element-75">
                <a href="#" className="hover:text-white transition-colors" data-id="element-76">
                  Politica de Confidențialitate
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="hover:text-white transition-colors" data-id="element-78">
                  Termeni și Condiții
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-white transition-colors" data-id="element-80">
                  Politica Cookies
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-white transition-colors" data-id="element-82">
                  GDPR
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-83">
          <p data-id="element-84">
            &copy; {new Date().getFullYear()} Daniela Sămărtinean. Toate
            drepturile rezervate.
          </p>
          <div className="flex items-center mt-4 md:mt-0" data-id="element-85">
            <Mail className="w-4 h-4 mr-2" data-id="element-86" />
            <a href="mailto:contact@danielasamartinean.ro" className="hover:text-white transition-colors" data-id="element-87">
              contact@danielasamartinean.ro
            </a>
          </div>
        </div>
      </div>
    </footer>;
}